import * as yup from "yup";

export const defaultUser = {
  role: "",
  permission: {},
};

export const userValidationSchema = yup.object().shape({
  role: yup.string().required("Role is required"),
});
